import { makeObservable } from 'mobx';

import { firebaseApp } from 'config/firebase';
import FirestoreCollectionService from 'services/FirestoreCollectionService';

const serviceConfig = {
    db: firebaseApp.firestore(),
    collectionName: 'brothers',
    objectSortColumn: 'createdOn',
    objectSortDirection: 'desc',
};
const storeConfig = {
    store: false,
    objectCollection: false,
};

class BrothersStore extends FirestoreCollectionService {
    store = null;

    constructor(store) {
        super(serviceConfig);
        makeObservable(this, storeConfig);
        this.store = store;
    }

    objectCollection = (view='default') => {
        let collectionRef = this.db.collection(this.collectionName);
        // if (view==='user' && this.store.auth.user!==null) {
        //     collectionRef = collectionRef.where('createdByUser','==',this.store.auth.user.uid);
        // }
        return collectionRef;
    };

    /**
     * Get information about a particular brother. Returns an empty object if no details have been stored yet.
     * @param {*} brotherId Firebase Auth User Id
     * @param {*} useCache Use Firestore Cache
     */
    getBrotherDetails = async (brotherId, useCache=true) => {
        let details = {};
        try {
            details = await this.getObject(brotherId, useCache);
        } catch(err) {
            console.log(err);
        }
        return details;
    }
}

export default BrothersStore;